import { X } from 'lucide-react'
import useHover from 'hooks/useHover'
import { FC, useEffect } from 'react'
import { cn, TooltipWrapper } from '@wellesley/ui'

import poll from './poll.svg'
import poll_active from './poll-active.svg'

export type PollControlProps = {
  isDisabled: boolean
  isPollPost?: boolean
  togglePollStep: () => void
}

const PollControl: FC<PollControlProps> = ({
  isPollPost,
  isDisabled,
  togglePollStep,
}) => {
  const [ref, isHovered, setIsHovered] = useHover<HTMLDivElement>()

  useEffect(() => {
    !isPollPost && setIsHovered(false)
  }, [isPollPost])

  const hasCloseButton = isPollPost && isHovered

  return (
    <div
      ref={ref}
      data-testid="poll-control-container"
      className={cn(
        'gap-xxs duration-custom flex items-center transition-all',
        {
          'p-xxs rounded-[6px] bg-gray-100': isPollPost,
          'w-16': hasCloseButton,
        },
      )}
    >
      <TooltipWrapper
        tooltipText={isDisabled ? 'Polls and media can’t be used together' : ''}
        align="center"
        theme="dark"
        size="small"
        triggerProps={{
          asChild: true,
        }}
      >
        <button
          onClick={isDisabled ? undefined : togglePollStep}
          className={cn('cursor-pointer', { 'opacity-50': isDisabled })}
        >
          <img
            height={24}
            src={isPollPost || (isHovered && !isDisabled) ? poll_active : poll}
            alt="poll"
          />
        </button>
      </TooltipWrapper>
      {hasCloseButton && (
        <button
          onClick={togglePollStep}
          className="cursor-pointer"
          data-testid="close-poll-button"
        >
          <X size={16} color="var(--gray-400)" />
        </button>
      )}
    </div>
  )
}

export default PollControl
